// Auto-generated by scripts/write-version.js. Do not edit manually.
export const APP_VERSION = '1.0.9';
